<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Upload Subcontract Request Delivery" active>

                                <b-row v-if="hasFailedDataSubcontractRequestDelivery">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedSubcontractRequestDelivery.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractRequestDeliverysFailed" :fields="fieldsSubcontractRequestDelivery" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractRequestDelivery" :sort-desc.sync="sortDescSubcontractRequestDelivery" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

													<template #cell(requestDeliveryQty)="row">
														{{ Number(row.item.requestDeliveryQty).toLocaleString() }}
													</template>
													<template #cell(requestDeliveryDate)="row">
														{{ row.item.requestDeliveryDate | moment("DD-MMM-YYYY") }}
													</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedSubcontractRequestDelivery.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="subcontractRequestDeliverys" :fields="fieldsSubcontractRequestDelivery" :busy="isDataLoading"
                                                         :sort-by.sync="sortBySubcontractRequestDelivery" :sort-desc.sync="sortDescSubcontractRequestDelivery" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

													<template #cell(requestDeliveryQty)="row">
														{{ Number(row.item.requestDeliveryQty).toLocaleString() }}
													</template>
													<template #cell(requestDeliveryDate)="row">
														{{ row.item.requestDeliveryDate | moment("DD-MMM-YYYY") }}
													</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            
							
						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import SubcontractRequestDelivery from '@/models/SubcontractRequestDelivery/SubcontractRequestDelivery';
import SubcontractRequestDeliveryList from '@/models/SubcontractRequestDelivery/SubcontractRequestDeliveryList';
import SubcontractRequestDeliveryFilter from '@/filters/SubcontractRequestDelivery/SubcontractRequestDeliveryFilter';
import toast from '@/mixins/toastMixin';
import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	mixins : [toast],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsSubcontractRequestDelivery: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partNumber', sortable: false},
				{"class" : "th-status", "label" : "Vendor Code", key: 'vendorCode', sortable: false},
				{"class" : "th-status", "label" : "PO Number", key: 'purchaseOrderNumber', sortable: false},
				{"class" : "th-status", "label" : "Request Delivery Qty", key: 'requestDeliveryQty', sortable: false},
				{"class" : "th-status", "label" : "Request Delivery Date", key: 'requestDeliveryDate', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsSubcontractRequestDeliveryDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding PO", key: 'poQtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Stock Vendor", key: 'stockVendor', sortable: false},
				{"class" : "th-status", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			subcontractRequestDeliverys : [],
			subcontractRequestDeliverysFailed: [],
			subcontractRequestDeliveryId : '',
			sortBySubcontractRequestDelivery: '',
			sortDescSubcontractRequestDelivery: '',
			hasFailedDataSubcontractRequestDelivery: false,
			totalFailedSubcontractRequestDelivery: 0,
			totalSucceedSubcontractRequestDelivery: 0,
			subcontractRequestDeliveryDetails : [],
			subcontractRequestDeliveryDetailsFailed: [],
			subcontractRequestDeliveryDetailId : '',
			sortBySubcontractRequestDeliveryDetail: '',
			sortDescSubcontractRequestDeliveryDetail: '',
			hasFailedDataSubcontractRequestDeliveryDetail: false,
			totalFailedSubcontractRequestDeliveryDetail: 0,
			totalSucceedSubcontractRequestDeliveryDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('subcontractrequestdelivery/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {

								_this.toast({ message: 'Upload Subcontract Request Delivery Berhasil!', title: 'Upload Success', variant: 'success' });

								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('subcontractrequestdelivery/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getSubcontractRequestDeliveryForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getSubcontractRequestDeliveryForUpload : async function() {
			let _this = this;
			this.$http.get('subcontractrequestdelivery/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.subcontractRequestDeliverys = [];

					if (response != null) {
						let result = response.data;
						_this.subcontractRequestDeliverys = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedSubcontractRequestDelivery = _this.subcontractRequestDeliverys.length;

						_this.subcontractRequestDeliverysFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataSubcontractRequestDelivery = true;
						_this.totalFailedSubcontractRequestDelivery = 0;
						if(_this.subcontractRequestDeliverysFailed == undefined || _this.subcontractRequestDeliverysFailed.length === 0) _this.hasFailedDataSubcontractRequestDelivery = false;
						if(_this.hasFailedDataSubcontractRequestDelivery) _this.totalFailedSubcontractRequestDelivery = _this.subcontractRequestDeliverysFailed.length;
						_this.hasFailedDataSubcontractRequestDeliveryDetail = true;
						_this.totalSucceedSubcontractRequestDeliveryDetail = 0;
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'subcontractrequestdelivery/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'SubcontractRequestDelivery.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterSubcontractRequestDelivery = new SubcontractRequestDeliveryFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
